import {connect}     from 'react-redux';
import dataThunks    from '../../store/actions/dataThunks';

import {productFormation} from '../../organisms/MainShop/constants';

const mapStateToProps = (state) => ({emailOrder: state.get('emailOrder')});

const mapDispatchToProps = (dispatch) => ({
  createPayment(actions, productId, lang, currency, promo) {
    return dispatch(dataThunks.createPayment(actions, productId, currency, productFormation(lang), promo));
  },
  sendOrderEmail(data, productID, price) {
    return dispatch(dataThunks.sendOrderEmail(data, productID, price));
  },
});

const buildController = (component) => connect(mapStateToProps, mapDispatchToProps)(component);

export default buildController;



// WEBPACK FOOTER //
// ./src/molecules/Product/ProductController.js